import {head} from 'ramda';

const FALLBACK_BALLOON_PAYMENT = 30;

/**
 * Picks the balloon bracket the matrix shows: the first candidate the bracket selector offers, so a
 * stale value never activates a bracket the panel does not display. `availableBalloons` is the full
 * bracket list the selector renders — including brackets without configured cells, which the user
 * must be able to activate in order to configure them.
 */
export function resolveActiveBalloonPayment(params: {
  availableBalloons: number[];
  selectedBalloon: number | null;
  activeBalloon: number | null;
  defaultBalloon: number | null;
}) {
  const availableCandidate = [
    params.selectedBalloon,
    params.activeBalloon,
    params.defaultBalloon,
  ].find((value): value is number => value !== null && params.availableBalloons.includes(value));

  return (
    availableCandidate ??
    head(params.availableBalloons) ??
    params.defaultBalloon ??
    params.activeBalloon ??
    params.selectedBalloon ??
    FALLBACK_BALLOON_PAYMENT
  );
}
